var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("table", { staticClass: "table table-hover" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.deals, function (deal, index) {
              return _c("tr", [
                _c("td", [
                  _vm._v(_vm._s(index + 1) + " (" + _vm._s(deal.id) + ")"),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(deal.title))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.$AllProjects[deal.site_id].title)),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    deal.last_upload
                      ? [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              _vm._s(
                                _vm.printDate(
                                  deal.last_upload.date,
                                  "DD.MM.YYYY HH:mm"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v("Препаратов: "),
                            _c("strong", [
                              _vm._v(_vm._s(deal.last_upload.drugs)),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.uploadDrugTypes[deal.settings.type]) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", [
                    _c("a", { attrs: { href: _vm.getFileLink(deal, true) } }, [
                      _vm._v(_vm._s(deal.settings.fileName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("a", { attrs: { href: _vm.getFileLink(deal) } }, [
                      _vm._v("upload.csv"),
                    ]),
                    _vm._v(" (для сверки)"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _vm.allowToUpload
                      ? [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info btn-xs",
                              on: {
                                click: function ($event) {
                                  return _vm.editDealSettings(deal)
                                },
                              },
                            },
                            [_vm._v("Редактировать")]
                          ),
                          _vm._v(" "),
                          _c(
                            "vue-ladda",
                            {
                              attrs: {
                                "button-class": "btn btn-success btn-xs",
                                "data-style": "zoom-in",
                                loading: _vm.uploadLoading[deal.id],
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.uploadDeal(deal)
                                },
                              },
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-upload" })]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-check" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.noUploadToCatalog,
                expression: "noUploadToCatalog",
              },
            ],
            staticClass: "form-check-input",
            attrs: { type: "checkbox", id: "exampleCheck11" },
            domProps: {
              checked: Array.isArray(_vm.noUploadToCatalog)
                ? _vm._i(_vm.noUploadToCatalog, null) > -1
                : _vm.noUploadToCatalog,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.noUploadToCatalog,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.noUploadToCatalog = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.noUploadToCatalog = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.noUploadToCatalog = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form-check-label",
              attrs: { for: "exampleCheck11" },
            },
            [
              _vm._v(
                "Не выгружать на справочные, только сгенерировать файлы\n        "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex justify-content-end" },
          [
            _vm._l(_vm.allowToUploadGroup, function (projectData, groupIndex) {
              return projectData.allow
                ? [
                    _c("LoadingButton", {
                      attrs: {
                        title: "Выгрузить " + projectData.title,
                        loading: projectData.loading,
                        disabled: projectData.disabledBtn,
                        color: _vm.$constants.SUCCESS_COLOR,
                        onClick: () => _vm.uploadGroup(groupIndex),
                        className: "btn btn-outline-success ml-2",
                      },
                    }),
                  ]
                : _vm._e()
            }),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.selectedDeal
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h5", [
              _vm._v("Справочная "),
              _c("strong", [_vm._v(_vm._s(_vm.selectedDeal.resource))]),
              _vm._v(" для\n        "),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.$AllProjects[_vm.selectedDeal.site_id].title)
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              attrs: { action: "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.updateDealOptions.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "mb-1" }, [
                  _c("h5", [
                    _vm._v("Выгрузка на основании "),
                    _c("strong", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.uploadDrugTypes[_vm.selectedDeal.settings.type]
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    +_vm.selectedDeal.settings.type === 1
                      ? _c("div", { staticClass: "form-check" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedDeal.settings.firstCode,
                                expression: "selectedDeal.settings.firstCode",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: { type: "checkbox", id: "first_code" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.selectedDeal.settings.firstCode
                              )
                                ? _vm._i(
                                    _vm.selectedDeal.settings.firstCode,
                                    null
                                  ) > -1
                                : _vm.selectedDeal.settings.firstCode,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedDeal.settings.firstCode,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.selectedDeal.settings,
                                        "firstCode",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.selectedDeal.settings,
                                        "firstCode",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.selectedDeal.settings,
                                    "firstCode",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: "first_code" },
                            },
                            [_vm._v("Выгружать только первый ЕГК код")]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedDeal.settings.ignoreRegistration,
                            expression:
                              "selectedDeal.settings.ignoreRegistration",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: { type: "checkbox", id: "exampleCheck1" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.selectedDeal.settings.ignoreRegistration
                          )
                            ? _vm._i(
                                _vm.selectedDeal.settings.ignoreRegistration,
                                null
                              ) > -1
                            : _vm.selectedDeal.settings.ignoreRegistration,
                        },
                        on: {
                          change: function ($event) {
                            var $$a =
                                _vm.selectedDeal.settings.ignoreRegistration,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.selectedDeal.settings,
                                    "ignoreRegistration",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.selectedDeal.settings,
                                    "ignoreRegistration",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.selectedDeal.settings,
                                "ignoreRegistration",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "exampleCheck1" },
                        },
                        [
                          _vm._v(
                            "Выгружать препараты независимо от наличия\n                гос.регистрации\n              "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedDeal.settings.uploadStoreOption,
                            expression:
                              "selectedDeal.settings.uploadStoreOption",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "options",
                          id: "exampleRadios1",
                          value: "1",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.selectedDeal.settings.uploadStoreOption,
                            "1"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.selectedDeal.settings,
                              "uploadStoreOption",
                              "1"
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "exampleRadios1" },
                        },
                        [
                          _vm._v(
                            "\n                Выгружать весь ассортимент\n              "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedDeal.settings.uploadStoreOption,
                            expression:
                              "selectedDeal.settings.uploadStoreOption",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "options",
                          id: "exampleRadios2",
                          value: "2",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.selectedDeal.settings.uploadStoreOption,
                            "2"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.selectedDeal.settings,
                              "uploadStoreOption",
                              "2"
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "exampleRadios2" },
                        },
                        [
                          _vm._v(
                            "\n                Выгружать ТОЛЬКО препараты, которые на момент формирования файла имеют свободные упаковки на складах\n                ЦС + МСК\n              "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedDeal.settings.uploadStoreOption,
                            expression:
                              "selectedDeal.settings.uploadStoreOption",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "options",
                          id: "exampleRadios3",
                          value: "3",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.selectedDeal.settings.uploadStoreOption,
                            "3"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.selectedDeal.settings,
                              "uploadStoreOption",
                              "3"
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "exampleRadios3" },
                        },
                        [
                          _vm._v(
                            "\n                Выгружать ТОЛЬКО препараты, которые на момент формирования файла имеют свободные упаковки на складе\n                МСК\n              "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "p-t-10 countries_ignored" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Игнорировать страны закупки"),
                        ]),
                        _vm._v(" "),
                        _c("multiselect", {
                          attrs: {
                            options: _vm.$AllCountries,
                            "track-by": "name",
                            label: "name",
                            disabled: _vm.ignoredCountriesDisabled,
                            "show-labels": false,
                            placeholder: "Выберите страну",
                            multiple: true,
                          },
                          model: {
                            value: _vm.countriesToIgnore,
                            callback: function ($$v) {
                              _vm.countriesToIgnore = $$v
                            },
                            expression: "countriesToIgnore",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Тип выгрузки"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedDeal.settings.uploadType,
                              expression: "selectedDeal.settings.uploadType",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.selectedDeal.settings,
                                "uploadType",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(_vm.uploadTypes, function (opt, value) {
                          return _c("option", { domProps: { value: value } }, [
                            _vm._v(_vm._s(opt)),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Логин")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedDeal.settings.login,
                            expression: "selectedDeal.settings.login",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { required: "", type: "text" },
                        domProps: { value: _vm.selectedDeal.settings.login },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.selectedDeal.settings,
                              "login",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Пароль")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedDeal.settings.password,
                            expression: "selectedDeal.settings.password",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { required: "", type: "text" },
                        domProps: { value: _vm.selectedDeal.settings.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.selectedDeal.settings,
                              "password",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Тип файла"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedDeal.settings.fileType,
                              expression: "selectedDeal.settings.fileType",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.selectedDeal.settings,
                                "fileType",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(_vm.fileTypes, function (type) {
                          return _c("option", { domProps: { value: type } }, [
                            _vm._v(_vm._s(type)),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      +_vm.selectedDeal.settings.uploadType === 1
                        ? [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Хост"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedDeal.settings.host,
                                    expression: "selectedDeal.settings.host",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { required: "", type: "text" },
                                domProps: {
                                  value: _vm.selectedDeal.settings.host,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.selectedDeal.settings,
                                      "host",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Порт"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedDeal.settings.port,
                                    expression: "selectedDeal.settings.port",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { required: "", type: "text" },
                                domProps: {
                                  value: _vm.selectedDeal.settings.port,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.selectedDeal.settings,
                                      "port",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Путь на сервере"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedDeal.settings.uploadPath,
                                    expression:
                                      "selectedDeal.settings.uploadPath",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { required: "", type: "text" },
                                domProps: {
                                  value: _vm.selectedDeal.settings.uploadPath,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.selectedDeal.settings,
                                      "uploadPath",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Имя файла"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedDeal.settings.fileName,
                              expression: "selectedDeal.settings.fileName",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { required: "", type: "text" },
                          domProps: {
                            value: _vm.selectedDeal.settings.fileName,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.selectedDeal.settings,
                                "fileName",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      +_vm.selectedDeal.settings.uploadType === 3
                        ? [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("E-mail для отправки"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.selectedDeal.settings.emailReceiver,
                                    expression:
                                      "selectedDeal.settings.emailReceiver",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { required: "", type: "text" },
                                domProps: {
                                  value:
                                    _vm.selectedDeal.settings.emailReceiver,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.selectedDeal.settings,
                                      "emailReceiver",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _vm.selectedDeal.settings.fileType === "yml" ||
                      _vm.selectedDeal.settings.fileType === "xml"
                        ? [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Имя шаблона для выгрузки"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.selectedDeal.settings.templateName,
                                    expression:
                                      "selectedDeal.settings.templateName",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { required: "", type: "text" },
                                domProps: {
                                  value: _vm.selectedDeal.settings.templateName,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.selectedDeal.settings,
                                      "templateName",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v("Поля выгрузки"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newField.name,
                              expression: "newField.name",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.newField.name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.newField,
                                "name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newField.value,
                              expression: "newField.value",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.newField.value },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.newField,
                                "value",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-success btn-xs",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.updateField(null, "add")
                              },
                            },
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-plus" })]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "table",
                        { staticClass: "table table-sm mt-1 table-hover" },
                        [
                          _vm._m(2),
                          _vm._v(" "),
                          _vm._l(
                            _vm.selectedDeal.settings.fileFields,
                            function (field, i) {
                              return _c("tr", [
                                _c("td", [_vm._v(_vm._s(field.name))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(field.value))]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-outline-danger btn-xs",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.updateField(i, "remove")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-trash text-center",
                                      }),
                                    ]
                                  ),
                                ]),
                              ])
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-footer text-right" },
                [
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        type: "submit",
                        "button-class": "btn btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.saveOptionsLoading,
                      },
                    },
                    [_vm._v("Сохранить\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Договоры на выгрузку")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Справочная")]),
        _vm._v(" "),
        _c("th", [_vm._v("Проект")]),
        _vm._v(" "),
        _c("th", [_vm._v("Файл обновлен")]),
        _vm._v(" "),
        _c("th", [_vm._v("Тип")]),
        _vm._v(" "),
        _c("th", [_vm._v("Файл")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Наименование поля")]),
        _vm._v(" "),
        _c("th", [_vm._v("Значение")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }